module.exports = __webpack_public_path__ + "img/zhinengjiaju5.94289ec2.jpg";